import * as Types from '../actions/Types'

const INITIAL_STATE = {
  isSigningIn: false,
  isValidatingToken: false,
  token: null
}

export default (state = INITIAL_STATE, action) => {
  const { payload, type } = action

  switch (type) {
    case Types.SIGN_IN_USER:
      return {
        ...state,
        isSigningIn: true
      }
    case Types.SIGN_IN_USER_SUCCESS:
      return {
        ...state,
        token: payload.token,
        isSigningIn: false
      }
    case Types.SIGN_IN_USER_FAILED:
      return {
        ...state,
        isSigningIn: false
      }
    case Types.VALIDATE_USER:
      return {
        ...state,
        isValidatingToken: true
      }
    case Types.VALIDATE_USER_SUCCESS:
      return {
        ...state,
        token: payload.token,
        isValidatingToken: false
      }
    case Types.VALIDATE_USER_FAILED:
      return {
        ...state,
        isValidatingToken: false
      }
    case Types.SIGN_OUT_USER:
      return INITIAL_STATE
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/components/reducers/User.js